import * as React from "react";
import { cn } from "../../lib/utils";

const Styles = () => {
  const css = `
    @keyframes orbit {
      from { transform: rotate(0deg); }
      to { transform: rotate(360deg); }
    }
    @keyframes counter-orbit {
      from { transform: rotate(0deg); }
      to { transform: rotate(-360deg); }
    }
    @keyframes float {
      0%, 100% { transform: translateY(0); }
      50% { transform: translateY(-10px); }
    }
    .oa-animate-orbit {
      animation: orbit var(--oa-orbit-duration) linear infinite;
    }
    .oa-animate-counter-orbit {
      animation: counter-orbit var(--oa-orbit-duration) linear infinite;
    }
    .oa-animate-float {
      animation: float 5s ease-in-out infinite;
    }
  `;
  return <style>{css}</style>;
};

interface Avatar {
  src: string;
  alt: string;
}

export interface OrbitingAvatarsCTAProps {
  children: React.ReactNode;
  avatars: Avatar[];
  className?: string;
  orbitRadius?: number;
  orbitDuration?: number;
}

export const OrbitingAvatarsCTA = ({
  children,
  avatars,
  className,
  orbitRadius = 18,
  orbitDuration = 40,
}: OrbitingAvatarsCTAProps) => {
  const radiusInPx = orbitRadius * 16;

  return (
    <>
      <Styles />
      <div className={cn("relative flex items-center justify-center overflow-hidden", className)}>
        {/* Background concentric circles */}
        <div className="pointer-events-none absolute inset-0 z-0 flex items-center justify-center">
          <div className="absolute h-[32rem] w-[32rem] rounded-full border border-dashed border-white/10" />
          <div className="absolute h-[48rem] w-[48rem] rounded-full border border-dashed border-white/5" />
        </div>

        {/* Central content */}
        <div className="relative z-10 flex flex-col items-center gap-4 px-4 text-center">
          {children}
        </div>

        {/* Orbiting avatars */}
        <div
          className="absolute inset-0 z-0 oa-animate-orbit flex items-center justify-center"
          style={{ "--oa-orbit-duration": `${orbitDuration}s` } as React.CSSProperties}
        >
          {avatars.map((avatar, i) => {
            const angle = (i / avatars.length) * 2 * Math.PI;
            const x = Math.cos(angle) * radiusInPx;
            const y = Math.sin(angle) * radiusInPx;

            return (
              <div
                key={i}
                className="absolute"
                style={{ transform: `translate(${x}px, ${y}px)` }}
              >
                <div
                  className="relative h-14 w-14 oa-animate-float"
                  style={{ animationDelay: `-${i * 0.7}s` }}
                >
                  <img
                    src={avatar.src}
                    alt={avatar.alt}
                    className="h-full w-full oa-animate-counter-orbit rounded-full object-cover shadow-lg ring-2 ring-white/20"
                    style={{ "--oa-orbit-duration": `${orbitDuration}s` } as React.CSSProperties}
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};
